import { SoQLType } from 'common/types/soql';

export const GROUP_COLUMN_PREFIX = 'ag-Grid-AutoColumn';
export const NULL_GROUPING = '__null_grouping__';
/**
 * Magic separator string used to split pivot fields from pivot result columns.
 *
 * '@@' was chosen arbitrarily by isaiahshiner.
 */
export const PIVOT_SEPARATOR = '@@';

export const LOCATION_AGGREGATION_TYPES = ['count'];
export const NUMERICAL_HIERARCHY_AGGREGATION_TYPES = ['sum', 'count', 'countDistinct', 'avg', 'min', 'max'];
export const NON_NUMERICAL_HIERARCHY_AGGREGATION_TYPES = ['count', 'countDistinct', 'min', 'max'];

export const DEFAULT_TABLE_HEADER_TEXT_COLOR = '#595959';
export const DEFAULT_TABLE_HEADER_BACKGROUND_COLOR = '#fff';

export const GROUPABLE_DATA_TYPES = new Set([
  SoQLType.SoQLNumberT,
  SoQLType.SoQLTextT,
  SoQLType.SoQLBooleanT,
  SoQLType.SoQLBooleanAltT,
  SoQLType.SoQLFixedTimestampT,
  SoQLType.SoQLFixedTimestampAltT,
  SoQLType.SoQLFloatingTimestampT,
  SoQLType.SoQLFloatingTimestampAltT,
  SoQLType.SoQLURLT,
  SoQLType.SoQLJsonT,
]);

export const HEADER_SORT_CYCLE = [null, 'ascending', 'descending', 'mixed'] as const;

export type HeaderSortType = (typeof HEADER_SORT_CYCLE)[number];
